import React, {FC, useState, useEffect} from 'react'
import {Modal, Spinner} from 'react-bootstrap'
import styles from './AddNoteModal.module.scss'

interface AddNoteModalProps {
  show: boolean
  onHide: () => void
  onSubmit: (noteText: string) => Promise<boolean>
  isSubmitting: boolean
}

const AddNoteModal: FC<AddNoteModalProps> = ({show, onHide, onSubmit, isSubmitting}) => {
  const [noteText, setNoteText] = useState('')

  // Reset form when modal opens
  useEffect(() => {
    if (show) {
      setNoteText('')
    }
  }, [show])

  const handleSubmit = async () => {
    if (!noteText.trim() || isSubmitting) return

    const success = await onSubmit(noteText.trim())
    if (success) {
      setNoteText('')
      onHide()
    }
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    // Submit on Cmd/Ctrl + Enter
    if ((e.metaKey || e.ctrlKey) && e.key === 'Enter') {
      e.preventDefault()
      handleSubmit()
    }
  }

  return (
    <Modal show={show} onHide={onHide} centered className={styles.addNoteModal}>
      <Modal.Header closeButton className={styles.modalHeader}>
        <Modal.Title className={styles.modalTitle}>Add Note</Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.modalBody}>
        <div className={styles.formGroup}>
          <label className={styles.label}>Note</label>
          <textarea
            className={styles.textarea}
            placeholder='Write your note here...'
            value={noteText}
            onChange={(e) => setNoteText(e.target.value)}
            onKeyDown={handleKeyDown}
            disabled={isSubmitting}
            rows={5}
            autoFocus
          />
          <span className={styles.hint}>Press Cmd/Ctrl + Enter to save</span>
        </div>
      </Modal.Body>
      <Modal.Footer className={styles.modalFooter}>
        <button type='button' className={styles.cancelBtn} onClick={onHide} disabled={isSubmitting}>
          Cancel
        </button>
        <button
          type='button'
          className={styles.submitBtn}
          onClick={handleSubmit}
          disabled={!noteText.trim() || isSubmitting}
        >
          {isSubmitting ? (
            <>
              <Spinner animation='border' size='sm' />
              Saving...
            </>
          ) : (
            <>
              <i className='bi bi-check-lg'></i>
              Save Note
            </>
          )}
        </button>
      </Modal.Footer>
    </Modal>
  )
}

export default AddNoteModal